import React from "react";

import { emitRecommenderRequest, FromProduct } from "@catchoftheday/analytics";

import { RECOMMENDER_EVENT_LIMIT } from "@personalisation/consts";
import { useRecommendedEventsV2Query } from "@personalisation/generated/graphql";

import { RecommenderCarousel } from "../RecommenderCarousel";
import { getEventTiles, getRecommenderTrackingData } from "../utils";

type RecommendedEventsProps = {
  productIds: string[];
  fromProduct: FromProduct;
  sourceType: number;
  sourceId?: string;
};

export const RecommendedEvents = ({
  productIds,
  fromProduct,
  sourceType,
  sourceId,
}: RecommendedEventsProps) => {
  const { data, error } = useRecommendedEventsV2Query({
    variables: { productIds, limit: RECOMMENDER_EVENT_LIMIT },
    ssr: false,
    onCompleted: ({
      recommendedEventsV2: {
        metaData: {
          preHydrationCount,
          postHydrationCount,
          hydrationErrorCount,
        },
      },
    }) => {
      emitRecommenderRequest({
        source_type: sourceType,
        pre_hydration_product_count: preHydrationCount,
        post_hydration_product_count: postHydrationCount,
        hydration_error_count: hydrationErrorCount,
        ...fromProduct,
      });
    },
  });

  if (!data?.recommendedEventsV2.events.length || error) {
    return null;
  }

  const events = data.recommendedEventsV2.events;
  const tiles = getEventTiles({ events, sourceType, fromProduct });
  const trackingData = getRecommenderTrackingData(events, "event");

  return (
    <RecommenderCarousel
      tiles={tiles}
      fromProduct={fromProduct}
      sourceType={sourceType}
      sourceId={sourceId}
      trackingData={trackingData}
      maxTiles={RECOMMENDER_EVENT_LIMIT}
      heading="Also worth checking out..."
      tilesPerBreakpoint={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3 }}
      carouselProps={{ showBullets: true }}
    />
  );
};
